<template>
  <div class="bg-light border-top">
    <!-- <hr /> -->
    <div class="row justify-content-center">
      <div class="col-12 col-md-8">
        <div class="row pt-5">
      <div class="col-12 col-md-4 text-center p-3 mb-3">
        <p class="caption">Академия ММА</p>
        <ul>
          <li>
            <a href="#">О проекте</a>
          </li>
          <li>
            <a href="#">Руководство</a>
          </li>
          <li>
            <a href="#">Сертификаты</a>
          </li>
        </ul>
      </div>
      <div class="col-12 col-md-4 text-center p-3 mb-3">
        <p class="caption">Сообщество</p>
        <ul>
          <li>
            <a href="#">Учащиеся</a>
          </li>
          <li>
            <a href="#">Партнёры</a>
          </li>
          <li>
            <a href="#">Блог</a>
          </li>
        </ul>
      </div>
      <div class="col-12 col-md-4 text-center p-3 mb-3">
        <p class="caption">Разное</p>
        <ul>
          <li>
            <a href="#">Условия</a>
          </li>
          <li>
            <a href="#">Конфиденциальность</a>
          </li>
          <li>
            <a href="#">Помощь</a>
          </li>
          <li>
            <a href="#">Контакты</a>
          </li>
        </ul>
      </div>
    </div>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {};
</script>

<style scoped>
.caption {
  font-size: 80%;
  font-weight: bold;
}
ul {
  padding: 0;
  list-style-type: none;
}
li {
  text-align: center;
}
li a {
  color: black;
  font-size: 75%;
}
</style>